export enum Action {
  CREATE = 'create-vault',
  DEPOSIT = 'deposit',
  REPAY = 'repay',
  BORROW = 'borrow',
  WITHDRAW = 'withdraw',
  REPOSSESS = 'repossess',
}
